module.exports = __webpack_public_path__ + "static/media/tocandoviolao.04d17a82.svg";